import React, { useState } from "react";

function ExperienceDetails(props) {
  const [expand, setExpand] = useState(false);

  function toggleExpand() {
    setExpand((prevValue) => !prevValue);
  }

  return (
    <div className="individual-resume-divs">
      <h2 className="h2-standard individual-resume-divs-headers">
        {props.heading}
      </h2>
      <h3 className="h3">{props.name}</h3>
      <h4 className="h4">({props.duration})</h4>
      <button className="buttons expand-buttons" onClick={toggleExpand}>
        {expand === false ? "+ More" : "- Less"}{" "}
      </button>

      {expand === true && (
        <>
          <div className="resume-bullet-points-div">
            {props.info.map((item, index) => (
              <p className="resume-bullet-points" key={index}>
                • {item}
              </p>
            ))}
          </div>

          {props.gitLink && (
            <a href={props.gitLink} rel="noopener noreferrer" target="_blank">
              <img
                src={require("../../media/github-icon.svg").default}
                alt="github-icon"
                className="git-icon"
              />
            </a>
          )}
        </>
      )}
    </div>
  );
}

export default ExperienceDetails;
